export default __webpack_public_path__ + "static/media/logo_small.590711b2.svg";